import { createReducer } from '@reduxjs/toolkit';
import { RequestError, ServiceTypesGroupingModeValues } from 'types';
import { exportUsers, exportedUsers, fetchUsers, fetchedUsers, resetFilters, setFilters } from './actions';
import { State } from './types';
import { saveBlob } from '../../utils/save-blob';

export const INITIAL_STATE: State = {
  status: undefined,
  error: undefined,
  data: undefined,
  filters: {
    firstName: undefined,
    lastName: undefined,
    profileID: undefined,
    groupName: undefined,
    serviceTypesGroupingMode: ServiceTypesGroupingModeValues.OU,
    trainTypeIDs: undefined,
    pageNumber: 1,
    maxResultPage: 10,
  },
};

// https://redux-toolkit.js.org/api/createReducer#the-builder-callback-api
export default createReducer<State>(INITIAL_STATE, (builder) =>
  builder
    .addCase(fetchUsers, (state) => {
      state.status = 'loading';
    })
    .addCase(fetchedUsers, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.error = payload as RequestError;
        state.status = 'error';
      } else {
        state.data = payload as State['data'];
        state.error = undefined;
        state.status = 'success';
      }
    })
    .addCase(exportUsers, (state) => {
      state.status = 'loading';
    })
    .addCase(exportedUsers, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.error = payload as RequestError;
        state.status = 'error';
      } else {
        const returnState = saveBlob(payload, 'users');
        state.error = returnState.error;
        state.status = returnState.status;
      }
    })
    .addCase(setFilters, (state, action) => {
      const { payload } = action;
      state.filters = payload;
    })
    .addCase(resetFilters, (state) => {
      state.filters = INITIAL_STATE.filters;
    })
);
